import { Form } from '@unform/web';
import styled from 'styled-components';

export const SelectedPlanContainer = styled.div`
  background: ${({ theme }) => theme.colors.lightBlue};
  padding: 20px 24px;
  border-radius: 15px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-top: 21px;

  span {
    font-weight: 700;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }
`;

export const PlanInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  span {
    font-weight: 500;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }

  .timeFrame {
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }
`;

export const PlanPriceContainer = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-weight: 400;
    font-size: 10px;
    color: ${({ theme }) => theme.colors.darkBlue2};
    line-height: 13px;
    text-align: right;
  }

  .highlightedText {
    font-weight: 600;
    font-size: 10px;
    color: ${({ theme }) => theme.colors.darkBlue2};
    line-height: 13px;
    text-align: right;
  }
`;

export const PriceContainer = styled.div`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.darkBlue2};
  background: ${({ theme }) => theme.colors.white};
  margin-bottom: 4px;

  span {
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.darkBlue2};
  }

  .smallText {
    font-size: 10px;
  }
`;

export const PaymentMethodContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin: 65px 0 23px 0;
  max-width: 450px;
`;

export const SelectedPaymentMethod = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 13px;

  span {
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.grey};
  }

  img {
    width: 19px;
    height: 19px;
  }
`;

export const ChangeMethodContainer = styled.div`
  cursor: pointer;

  span {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
  }
`;

export const ContainerForm = styled(Form)`
  h2 {
    margin: 40px 0px;
    font-weight: 600;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.grey};
  }

  max-width: 450px;
`;

export const InstructionsContainer = styled.div`
  margin-top: 56px;

  h1 {
    font-weight: 600;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grey};
    margin-bottom: 31px;
  }

  div span {
    font-weight: 500;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.grey1};
  }

  .middleText {
    margin: 20px 0;
  }

  .highlighted {
    font-weight: 700;
  }
`;
